import type { ModalContext } from './modal.types'

import { createContext } from '../utils'

const [ModalProvider, useModalContext] = createContext<ModalContext>({ isOptional: true })

export { ModalProvider, useModalContext }
